import type { Event } from "@circle-react/types/Event";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { EventItem } from "./EventItem";

interface EventsModalProps {
  allEvents: Event[];
  date: string;
  events: Event[];
  isOpen: boolean;
  onChange: (event: Event) => void;
  onClose: () => void;
}

export const EventsModal = ({
  events,
  date,
  onChange,
  allEvents,
  isOpen,
  onClose,
}: EventsModalProps) => (
  <Modal isOpen={isOpen} onClose={onClose} className="!z-[50]">
    <Modal.Overlay />
    <Modal.Content>
      <Modal.Header>
        <Modal.Title size="sm" className="text-center">
          <Typography.LabelMd weight="bold">{date}</Typography.LabelMd>
        </Modal.Title>
        <Modal.HeaderActions>
          <Modal.CloseButton onClick={onClose} />
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body className="overflow-y-auto py-4 md:!px-6">
        {events.map(eventItem => (
          <EventItem
            key={eventItem.id}
            eventItem={eventItem}
            allEvents={allEvents}
            onChange={onChange}
          />
        ))}
      </Modal.Body>
    </Modal.Content>
  </Modal>
);
